import { Input } from 'antd';

const TextArea = Input.TextArea;

export { TextArea };
export { type InputProps as TextAreaProps } from 'antd';
